import { Model } from 'pinia-orm';
import { Bool, HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import Project from './Project';
import ProjectSupplier from './ProjectSupplier';
/* --- user header --- */
/* --- end user header --- */

export default class Company extends Model {
  static entity = 'App\\Models\\Company';
  // fields
  @Num(0)
  declare id: number;
  @Str('')
  declare name: string;
  @Str(undefined)
  declare acn: string | undefined;
  @Str(undefined)
  declare abn: string | undefined;
  @Str(undefined)
  declare office_address: string | undefined;
  @Str(undefined)
  declare contact_name: string | undefined;
  @Str(undefined)
  declare contact_phone: string | undefined;
  @Str(undefined)
  declare contact_email: string | undefined;
  @Str(undefined)
  declare general_notices_email: string | undefined;
  @Bool(false)
  declare feature_flag_subcontractor_claims_lite: boolean;
  @Str('')
  declare business_role: string;
  @Str('')
  declare type: 'all' | 'contractor' | 'client';
  @Num(0)
  declare max_projects: number;
  @Num(0)
  declare log_retention_period: number;
  @Str('')
  declare created_at: string | undefined;
  @Str('')
  declare updated_at: string | undefined;
  // relations
  @HasMany(() => Project, 'company_id', 'id')
  declare projects: Project[];
  @HasMany(() => ProjectSupplier, 'company_id', 'id')
  declare suppliers: ProjectSupplier[];
  /* --- user code --- */
  /* --- end user code --- */
}
